import {
  TASK_FEED_PLATFORM_ORDER,
  type TaskFeedPlatform
} from '../TaskFeedCard/taskFeedCard.constants'

/**
 * The Platforms menu: the union of the `available_platforms` the tab's lists
 * returned (each counted over all of its pages), in the menu order.
 * Values this build has no icon for are dropped.
 */
export function collectFeedPlatforms(
  lists: readonly (readonly string[] | undefined)[]
): TaskFeedPlatform[] {
  const present = new Set(lists.flatMap(list => list ?? []))
  return TASK_FEED_PLATFORM_ORDER.filter(platform => present.has(platform))
}

/** Picked platforms the tab no longer offers are dropped. */
export function resolveFeedPlatforms(
  picked: readonly TaskFeedPlatform[],
  platforms: readonly TaskFeedPlatform[]
): readonly TaskFeedPlatform[] {
  const kept = picked.filter(platform => platforms.includes(platform))
  return kept.length === picked.length ? picked : kept
}

/** The `platforms` query param; none for All platforms. */
export function toFeedPlatformsParam(
  picked: readonly TaskFeedPlatform[]
): TaskFeedPlatform[] | undefined {
  return picked.length > 0 ? [...picked] : undefined
}
